import type { CheckoutFormSchema } from '@features/purchasing/checkout/schema';
import CheckoutBreadcrumbs from '@features/purchasing/components/CheckoutBreadcrumbs';
import type { ICheckoutStep } from '@features/purchasing/types';

import CheckoutForm from './CheckoutForm';
import StepAdditionalInformation from './steps/StepAdditionalInformation';
import StepCustomer from './steps/StepCustomer';
import StepMethods from './steps/StepMethods';
import Widgets from './steps/Widgets';
import type { ICheckoutAddress, ICheckoutCustomer, IPaymentMethod, IShippingMethod } from './types';

export interface CheckoutProps {
  title: string;
  steps: ICheckoutStep[];
  note?: string;
  customer: ICheckoutCustomer;
  dpdApiKey?: string;
  dpdPickupPoint?: CheckoutFormSchema['dpdPickupPoint'];
  shippingAddresses?: ICheckoutAddress[];
  countries: Record<string, string>;
  weight: number;
  methods: {
    shippingMethodId?: string;
    shippingMethods: IShippingMethod[];
    paymentMethodId?: string;
    paymentMethods: IPaymentMethod[];
  };
  urls: {
    setWizard: string;
    previousStep: string;
    nextStep: string;
    authenticate?: string;
    registration?: string;
  };
}
export default function Index({
  weight,
  steps,
  note,
  customer,
  dpdPickupPoint,
  dpdApiKey,
  shippingAddresses,
  countries,
  methods,
  urls: { previousStep, nextStep, setWizard, authenticate, registration },
}: CheckoutProps) {
  return (
    <>
      <div className="flex flex-col mx-auto">
        {steps && <CheckoutBreadcrumbs steps={steps} />}

        {/*<h1 className="flex flex-col laptop:flex-row items-center laptop:items-baseline laptop:justify-center gap-x-2">*/}
        {/*  <small className="text-accent-300">{title}</small>*/}
        {/*</h1>*/}

        <CheckoutForm
          customer={customer}
          dpdPickupPoint={dpdPickupPoint}
          shippingMethodId={methods.shippingMethodId}
          paymentMethodId={methods.paymentMethodId}
          note={note}
          nextStepUrl={nextStep}
          setCheckoutWizardUrl={setWizard}>
          <StepCustomer shippingAddresses={shippingAddresses} countries={countries} {...customer} />
          <Widgets customer={customer} registerUrl={registration} authenticateUrl={authenticate} />
          <StepMethods {...methods} weight={weight} dpdApiKey={dpdApiKey} />
          <StepAdditionalInformation onBack={() => (location.href = previousStep)} />
        </CheckoutForm>
      </div>
    </>
  );
}
